import axios from "axios";
import { __constants } from "../constants";
import { createQuery } from "../utils";
const BASE_URL = process.env.REACT_APP_SERVER_URL;

export const getUserPaymentList = async (query) => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/admin/payments?limit=" + __constants.listingLimit + "&" + createQuery(query),
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            }
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        return err.response
    }
}

export const getUserPaymentDetails = async (paymentId) => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/admin/payments/" + paymentId,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            }
        };
        const response = await axios(config);
        console.log("Info--->", response.data.data.payment[0])
        return response;
    } catch (err) {
        return err.response
    }
}

export const getProviders = async (role) => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/admin/payment/providers/" + role,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            }
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        return err.response
    }
}

export const markPaymentAsPaid = async (data) => {
    try {
        const config = {
            method: 'PUT',
            url: BASE_URL + "/v1/admin/payment",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
            data
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        return err.response
    }
}

export const getWithdrawRequest = async (query) => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/admin/payment/withdraw-request?limit=" + __constants.listingLimit + "&" + createQuery(query),
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            }
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        return err.response
    }
}